import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';

export function fromContentBuilderColor(
  contentBuilderColor?: IContentBuilderFieldColor,
  defaultFallback?: string | IContentBuilderFieldColor,
): string {
  if (
    !contentBuilderColor ||
    !contentBuilderColor?.value ||
    !contentBuilderColor?.type ||
    contentBuilderColor.type === ColorFieldTypesValues.Default
  ) {
    if (!defaultFallback || typeof defaultFallback === 'string') {
      const result =
        defaultFallback?.split('-').length === 2
          ? `var(--ui-color-${defaultFallback})`
          : defaultFallback || '';

      return result;
    }
    return fromContentBuilderColor(defaultFallback);
  }

  if (contentBuilderColor.type === ColorFieldTypesValues.Palette) {
    return `var(--ui-color-${contentBuilderColor.value})`;
  }

  if (contentBuilderColor.type === ColorFieldTypesValues.Hex) {
    return contentBuilderColor.value;
  }

  return '';
}
